import axios from 'axios';
import moment from 'moment';
import { firebaseAction, firebaseMutations } from 'vuexfire';
import { db } from '../../firebase';
import { APPS } from '../../const';

const state = {
  owner: { '.value': null },
  accessedUsers: [],
  actualUser: undefined,
  actualDevice: null,
  app: null,
};

const getters = {
  isOwner: state => state.owner['.value'] !== null,
  isHelper: state => state.accessedUsers.length !== 0,
  owner: state => state.owner,
  accessedUsers: state => state.accessedUsers,
  uid: (state, getters, rootState) => rootState.user.data.uid,
  // uid: () => getCookieByName('uid'),
  uemail: (state, getters, rootState) => rootState.user.data.email,
  // devices: state => (state.owner.devices ? state.owner.devices : {}),
  devices(state) {
    if (state.owner && state.owner.devices) {
      const keys = Object.keys(state.owner.devices)
        .filter(key => state.owner.devices[key].meta.enabled === false);
      const copy = Object.assign({}, state.owner.devices);
      keys.forEach(item => delete copy[item]);
      return copy;
    }
    return state.owner.devices || {};
  },
  app: state => state.app,
  meta: state => (state.actualDevice !== null ? state.actualDevice.meta : {}),
  appData(state, getters) {
    return {
      uid: getters.uid,
      did: state.actualDevice !== null ? state.actualDevice['.key'] : null,
      aid: state.app !== null ? state.app['.key'] : null,
    };
  },
};

const actions = {
  async _init({ dispatch }) {
    await dispatch('_initOwner');
    // await dispatch('_initHelper');
  },
  _initOwner: firebaseAction(async ({ getters, bindFirebaseRef }) => {
    await bindFirebaseRef('owner', db.ref(`/users/${getters.uid}`));
  }),
  _initActualDevice: firebaseAction(async ({ getters, bindFirebaseRef }, deviceID) => {
    await bindFirebaseRef('actualDevice', db.ref(`/users/${getters.uid}/devices/${deviceID}`));
  }),
  _initApp: firebaseAction(async (context, app) => {
    if (state.app !== null) context.unbindFirebaseRef('app');
    const { uid, did } = context.getters.appData;
    await context.bindFirebaseRef('app', db.ref(`/users/${uid}/devices/${did}/apps/${app}`));
  }),
  async addData(context, data) {
    const { uid, did, aid } = context.getters.appData;
    let ref = `/users/${uid}/devices/${did}/apps/${aid}/`;
    if ('sub' in data) ref = `${ref}/${data.sub}`;
    await db.ref(ref).push(data.data);
  },
  async setData(context, data) {
    const { uid, did, aid } = context.getters.appData;
    await db.ref(`/users/${uid}/devices/${did}/apps/${aid}/${data.id}/`).set(data.data);
  },
  async updateData(context, data) {
    const updates = {};
    const { uid, did, aid } = context.getters.appData;
    updates[`/users/${uid}/devices/${did}/apps/${aid}/${data.id}/`] = data.data;
    await db.ref().update(updates);
  },
  async deleteData(context, data) {
    const { uid, did, aid } = context.getters.appData;
    await db.ref(`/users/${uid}/devices/${did}/apps/${aid}/${data.id}/`).remove();
  },
  async deleteApp(context) {
    const { uid, did, aid } = context.getters.appData;
    await db.ref(`/users/${uid}/devices/${did}/apps/${aid}/`).remove();
  },
  async deleteAppKey(context, key) {
    const { uid, did, aid } = context.getters.appData;
    await db.ref(`/users/${uid}/devices/${did}/apps/${aid}/${key}`).remove();
  },
  bindHistory: firebaseAction(async (context, filter) => {
    if (state.app !== null) context.unbindFirebaseRef('app');
    const { uid, did } = context.getters.appData;
    const aid = APPS.HISTORY_APP;
    let ref = db.ref(`/users/${uid}/devices/${did}/apps/${aid}`);
    ref = ref.orderByChild('datetime').startAt(filter.startAt).endAt(filter.endAt).limitToLast(1000);
    await context.bindFirebaseRef('app', ref);
  }),
  async addHistoryEntry(context, data) {
    const payload = data;
    const { uid, did } = context.getters.appData;
    payload.datetime = moment().unix();
    if (payload.allDevices) {
      delete payload.allDevices;
      Object.entries(context.getters.devices).forEach(async ([key]) => {
        await db.ref(`/users/${uid}/devices/${key}/apps/${APPS.HISTORY_APP}`).push(payload);
      });
    } else {
      await db.ref(`/users/${uid}/devices/${did}/apps/${APPS.HISTORY_APP}`).push(payload);
    }
  },
  async _initHelper({ state, getters, commit, rootGetters }) {
    if (state.accessedUsers.length === 0) {
      const email = getters.uemail.replace(/\./g, '__dot__');
      try {
        const response = await axios.get(`${rootGetters.api.users}/invites`, { headers: { email } });
        commit('SAVE_ACCESSED_USERS', response.data);
      } catch (e) {
        commit('ADD_ERROR', e.message);
      }
    }
  },
  getUserData: firebaseAction(({ bindFirebaseRef }, data) => {
    bindFirebaseRef('actualUser', db.ref(`/users/${data}`));
  }),
  addUserInvite: ({ getters }, data) => {
    const key = data.email.replace(/\./g, '__dot__');
    db.ref(`/users/${getters.uid}/invites/${key}`).set(data.scope);
  },
};

const mutations = {
  ...firebaseMutations,
  SAVE_ACCESSED_USERS(state, payload) {
    state.accessedUsers = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/fire.js